import * as tslib_1 from "tslib";
import * as React from 'react';
import cn from 'astro-classname';
import omit from 'lodash/omit';
import '../button/index.css';
var BLACK_LIST = [
    'theme',
    'size',
    'htmlType',
    'block',
    'disabled',
    'loading',
    'className',
    'outline',
    'round',
    'prefix',
    'href',
    'target',
    'kong'
];
var isTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var Button = (function (_super) {
    tslib_1.__extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) {
            var _a = _this.props, disabled = _a.disabled, onClick = _a.onClick;
            if (disabled) {
                return;
            }
            if (onClick) {
                onClick(e);
            }
        };
        return _this;
    }
    Button.prototype.isInsertSpace = function () {
        var children = this.props.children;
        return React.Children.count(children) === 1;
    };
    Button.prototype.wrapValueBySpan = function (children, isNeedInserted) {
        if (children == null) {
            return null;
        }
        var SPACE = isNeedInserted ? ' ' : '';
        return React.Children.map(children, function (child) {
            if (typeof child === 'string') {
                if (isTwoCNChar.test(child)) {
                    return React.createElement("span", null, child.split('').join(SPACE));
                }
                return React.createElement("span", null, child);
            }
            return child;
        });
    };
    Button.prototype.renderLink = function (classes, children) {
        var _a = this.props, disabled = _a.disabled, _b = _a.href, href = _b === void 0 ? '' : _b, target = _a.target;
        var nodeProps = omit(this.props, BLACK_LIST);
        return (React.createElement("a", tslib_1.__assign({}, (disabled ? {} : { href: href, target: target }), nodeProps, { className: classes, onClick: this.handleClick }), children));
    };
    Button.prototype.renderButton = function (classes, children) {
        var _a = this.props, disabled = _a.disabled, loading = _a.loading, htmlType = _a.htmlType;
        var nodeProps = omit(this.props, BLACK_LIST);
        return (React.createElement("button", tslib_1.__assign({}, nodeProps, (htmlType ? { type: htmlType } : {}), { className: classes, disabled: disabled || loading, onClick: this.handleClick }), children));
    };
    Button.prototype.render = function () {
        var _a;
        var _b = this.props, href = _b.href, target = _b.target, className = _b.className, theme = _b.theme, size = _b.size, disabled = _b.disabled, loading = _b.loading, outline = _b.outline, round = _b.round, block = _b.block, children = _b.children, prefix = _b.prefix, kong = _b.kong;
        var renderName = href || target ? 'renderLink' : 'renderButton';
        var classes = cn(prefix, className, (_a = {},
            _a[prefix + "-" + theme + (outline ? '-outline' : '')] = theme && !kong,
            _a[prefix + "-" + size] = size && size !== 'medium',
            _a[prefix + "-disabled"] = disabled,
            _a[prefix + "-loading"] = loading,
            _a[prefix + "-block"] = block,
            _a[prefix + "-round"] = round,
            _a[(round || outline || disabled ? '' : prefix) + "-kong-" + kong] = kong,
            _a));
        var wrapperChildren = this.wrapValueBySpan(children, this.isInsertSpace());
        return this[renderName](classes, wrapperChildren);
    };
    Button.defaultProps = {
        className: '',
        theme: 'default',
        size: 'medium',
        disabled: false,
        loading: false,
        outline: false,
        round: false,
        block: false,
        kong: '',
        prefix: 'zhui-btn'
    };
    return Button;
}(React.Component));
export default Button;
